module.exports = __webpack_public_path__ + "img/icons BFr_6.fd644ac1.svg";